import {AnyAction} from 'redux';
import {MonitorReducer as State} from '../../@types/reducers';
import {
    BOOK_EVENT_SUCCESS,
    DELETE_ALERT_SUCCESS,
    DELETE_MONITOR_SETTINGS_SUCCESS,
    EDIT_MONITOR_EVENT,
    GET_EVENT_SUCCESS,
    GET_EVENTS,
    GET_EVENTS_SUCCESS,
    GET_MONITOR_SETTINGS_SUCCESS,
    HIDE_ALERT_SUCCESS,
    MONITOR_INITIALIZE_SUCCESS,
    NEW_BOOKED_EVENT,
    NEW_HIDDEN_ALERT,
    SET_ACTIVE_EVENTS,
    SET_ORDER,
    SET_SETTINGS,
    STORE_MONITOR_INITIALIZE,
} from "../../constants/MonitorConstants";
import {buildSettings, processEvent} from "../utils/monitorUtils";
import {GET_BOOKS_SUCCESS} from "../../constants/UserConstants";
import {AlertMonitorObject, EventStoredObject} from '../../@types/response';
import {ActiveEventIds} from "../utils/searchFixtures";

const initialState: State = {
    initializing: true,
    event: undefined,
    monitors: [],
    booked: [],
    hides: {},
    books: [],
    activeEventIds: new Set<number>(),
    template: null,
    templates: [],
    settings: {
        bookmakers: [],
        comparisons: {},
        date: 0,
        from: 1,
        to: 1,
        order: 3,
        onlyDrop: false,
        playability: 0,
        sports: {1: true, 2: true, 5: true}
    }
};

const monitorReducer = (state = initialState, action: AnyAction): State => {
    switch (action.type) {
        case SET_SETTINGS: {
            const settings = Object.assign({}, state.settings, action.payload)
            return {
                ...state,
                settings: settings,
            }
        }
        case STORE_MONITOR_INITIALIZE: {
            if (state.templates.includes(action.payload.name))
                return state
            return {
                ...state,
                templates: [...state.templates, action.payload.name]
            }
        }
        case MONITOR_INITIALIZE_SUCCESS: {
            const settings = Object.assign({}, state.settings, buildSettings(action.payload.settings))
            return {
                ...state,
                initializing: false,
                booked: action.payload.booked,
                hides: action.payload.hides,
                settings: settings,
                templates: action.payload.templates,
            };
        }
        case GET_MONITOR_SETTINGS_SUCCESS: {
            return {
                ...state,
                initializing: false,
                settings: buildSettings(action.payload.settings),
                template: action.payload.template
            };
        }
        case DELETE_MONITOR_SETTINGS_SUCCESS: {
            return {
                ...state,
                templates: state.templates.filter((item: string) => item !== action.payload.template)
            };
        }
        case GET_EVENTS: {
            return {
                ...state,
                initializing: true
            }
        }
        case GET_EVENTS_SUCCESS: {
            const monitors: AlertMonitorObject[] = action.payload.events.map((e: EventStoredObject) => processEvent(e, state.settings, state.booked, state.hides, action.payload.marketsCap, action.payload.moneyLines[e._id])).flat()
            return {
                ...state,
                monitors,
                initializing: false
            };
        }
        case EDIT_MONITOR_EVENT: {
            const _newAlerts: AlertMonitorObject[] = processEvent(action.payload.event, state.settings, state.booked, state.hides, action.payload.marketsCap, action.payload.moneyLines[action.payload.event._id])
            const _rmAlerts = state.monitors.filter(_m => _m.id !== action.payload.event._id)
            let _monitors = !_newAlerts.length && state.monitors.length === _rmAlerts.length ? state.monitors :
                _rmAlerts.concat(_newAlerts)
            const eventId: number = action.payload.event._id
            const hasActive: boolean = !!action.payload.event.bookmakers
                && Object.keys(action.payload.event.bookmakers).length > 0
            const activeEventIds = new Set(state.activeEventIds)
            if (hasActive) {
                activeEventIds.add(eventId)
            } else {
                activeEventIds.delete(eventId)
            }
            return {
                ...state,
                monitors: _monitors,
                activeEventIds,
            };
        }
        case SET_ORDER: {
            return {
                ...state,
                settings: Object.assign({}, state.settings, {order: action.payload})
            };
        }
        case SET_ACTIVE_EVENTS: {
            const activeEventIds: ActiveEventIds = new Set<number>(action.payload)
            return {
                ...state,
                activeEventIds,
            };
        }
        case GET_EVENT_SUCCESS: {
            return {
                ...state,
                event: action.payload
            };
        }
        case GET_BOOKS_SUCCESS: {
            return {
                ...state,
                books: action.payload
            };
        }
        case BOOK_EVENT_SUCCESS:
        case NEW_BOOKED_EVENT: {
            const booked = [...state.booked, action.payload]
            return {
                ...state,
                booked: booked,
                monitors: state.monitors.filter(alert => action.payload !== (alert.sbv ? `${alert.id}-${alert.marketId}@${alert.sbv}-${alert.signId}` : `${alert.id}-${alert.marketId}-${alert.signId}`))
            };
        }
        case DELETE_ALERT_SUCCESS: {
            return {
                ...state,
                monitors: state.monitors
                    .filter(alert => {
                        return !(alert.id === action.payload.eventId
                            && alert.marketId === action.payload.marketId)
                    })
            }
        }
        case HIDE_ALERT_SUCCESS:
        case NEW_HIDDEN_ALERT: {
            const hides = Object.assign({}, state.hides, action.payload)
            return {
                ...state,
                hides: hides,
                monitors: state.monitors.filter(alert => !Object.keys(action.payload).includes(`${alert.id}-${alert.marketId}-${alert.signId}`))
            };
        }
        default:
            return state;
    }
};

export default monitorReducer;
